// src/components/security/ProtectedRoute.tsx
import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useSecureAuth } from "../../services/useSecureAuth";

interface Props {
  element: JSX.Element;
}

const ProtectedRoute: React.FC<Props> = ({ element }) => {
  const { isAuthenticated, loading } = useSecureAuth();

  if (loading) return <p>Cargando...</p>;
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
